import type { CRMUser } from "@swivl-mono/types";
import React from "react";

import { CustomerListItem } from "./CustomerListItem";

interface CustomerListProps {
  users: CRMUser[];
  selectedUserId?: number | null;
  onSelect: (user: CRMUser) => void;
}

export function CustomerList({ users, selectedUserId, onSelect }: CustomerListProps): React.ReactNode {
  return (
    <div className="flex flex-col">
      {users.map((user) => (
        <CustomerListItem key={user.id} user={user} selected={user.id === selectedUserId} onSelect={onSelect} />
      ))}
    </div>
  );
}
